module.exports = __webpack_public_path__ + "img/favicons/ape/favicon-32x32.png";